import React, { Fragment, useState } from 'react';
import PropTypes from 'prop-types';
import { TransitionGroup } from 'react-transition-group';

import ScrollToDismiss from 'core/components/ScrollToDismiss';
import { CartProvider } from 'core/providers/CartContext';

import ShopBagItem from './ShopBagItem';
import {
	CartListHeader,
	CartListContainer,
	CartListHeaderContainer,
	CaretUp,
} from './styles';

const CartList = ({
	carts = [], removeItem, onClose, open,
}) => {
	const isAllowMulticart = CartProvider.isAllowMulticart();
	const cjpCarts = CartProvider.findCJPCarts(carts);
	const cjpCartsTestMode = CartProvider.findCJPCarts(carts, true); // testMode = true
	const nonCJPCarts = CartProvider.findNonCJPCarts(carts);

	return (
		<CartListContainer in={open} unmountOnExit={true} timeout={500}>
			<ScrollToDismiss onClose={onClose} closeAtDistance={120}>
				<Fragment>
					<CartListHeaderContainer>
						<CartListHeader>Your cart</CartListHeader>
						<CaretUp onClick={onClose} />
					</CartListHeaderContainer>
					<TransitionGroup component={null}>
						{!isAllowMulticart ? carts.map(cart => <ShopBagItem
							key={cart.id}
							remove={removeItem}
							{...cart}
						/>) : <>
							{cjpCarts.map((cart, idx) => <ShopBagItem
								key={cart.id}
								remove={removeItem}
								{...cart}
								cartCount={cjpCarts.length}
								firstItem={idx === 0}
							/>)}
							{cjpCartsTestMode.map((cart, idx) => <ShopBagItem
								key={cart.id}
								remove={removeItem}
								{...cart}
								cartCount={cjpCartsTestMode.length}
								firstItem={idx === 0}
							/>)}
							{nonCJPCarts.map(cart => <ShopBagItem
								key={cart.id}
								remove={removeItem}
								{...cart}
							/>)}
						</>}
					</TransitionGroup>
					{carts.length === 0 && (
						<div>Your cart is empty. Go put some things in it!</div>
					)}
				</Fragment>
			</ScrollToDismiss>
		</CartListContainer>
	);
};

CartList.propTypes = {
	carts: PropTypes.arrayOf(PropTypes.object),
	removeItem: PropTypes.func.isRequired,
	onClose: PropTypes.func.isRequired,
	open: PropTypes.bool.isRequired,
};

CartList.defaultProps = {};

export default CartList;
